import JobPostingSection from "./JobPostingSection";

export default JobPostingSection;
